<div  mat-dialog-title>
  <div class="titulo-container">
      <h1 class="titulo-simpli">{{this.business_name}}</h1>
      <span class="rut-label">{{this.rut}}</span>
</div>

<div mat-dialog-content>

  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" dynamicHeight="true" (selectedTabChange)="tabChanged($event)" [selectedIndex]="tabIndex">
      <mat-tab label="Cuentas registradas">
        

        <div class="row animate__animated animate__fadeIn" *ngIf="cuentas.length == 0 && loading_cuentas" style="margin-top: 30px;">
          
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="sinRegistros" style="text-align: center;">
                  <small class="small-sinregistros" style="font-size: 15px;margin-top: 20px;">
                    <div style="text-align: center;">
                      <i style="font-size: 30px;margin-bottom: 20px;" class="fa-solid fa-circle-notch fa-spin-pulse"></i>
                  </div>
                  </small>
              </div>
          </div>
              
        </div>


        <div class="row animate__animated animate__fadeIn" *ngIf="cuentas.length > 0 && !loading_cuentas">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="margin-top: 30px;">
                <ctas [cuentas]="cuentas" [bancos]="bancos" [token]="token" [role]="role" [id_company]="id_company" [actualizar]="actualizar" [companyRun]="rut" *ngIf="tabIndex === 0"></ctas>
          </div>
        </div>

        <div class="row animate__animated animate__fadeIn" *ngIf="cuentas.length == 0 && !loading_cuentas" style="margin-top: 30px;">
    
          <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
  
              <div class="sinRegistros" style="text-align: center;">
                  <small class="small-sinregistros" style="font-size: 15px;">
                    <div style="text-align: center;"><i style="font-size: 30px;color:gray;margin-bottom: 20px;" class="fa-light fa-empty-set"></i></div>
                    No hay información.
                  </small>
              </div>
          </div>
    
        </div>

      </mat-tab>

      <mat-tab label="Nueva cuenta">

        <div class="row animate__animated animate__fadeIn">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="margin-top: 20px;">
            <create-cuenta-bancaria [cuentas]="cuentas" [bancos]="bancos" [load_data]="false" [id_company]="id_company"
              (funciones)="procesaPropagar($event)" (irAPrimeraTab)="accountCreatedChangeTab()" [companyRun]="rut"></create-cuenta-bancaria>
          </div>
        </div>

      </mat-tab>



    </mat-tab-group>

  </div>

</div>

<div style="margin-top: 10px;" mat-dialog-actions>
  <button *ngIf="open_as_dialog == false" class="secondary-button" mat-stroked-button color="primary" (click)="close()">Volver</button>
  <button *ngIf="open_as_dialog == true" class="secondary-button" mat-stroked-button color="primary" mat-dialog-close>Cerrar</button>
</div>
